/**
 * Add to Cart Popup Module
 * HTML is rendered by PHP via AJAX, JS handles only actions
 */
import popups from "./motion/popups";

const addToCartPopup = {
    init() {
        this.createOverlay();
        this.bindEvents();
    },

    createOverlay() {
        if (document.querySelector('.atc-popup-overlay')) {
            return;
        }
        document.body.insertAdjacentHTML('beforeend', '<div class="atc-popup-overlay"></div>');
    },

    bindEvents() {
        const self = this;

        // Intercept WooCommerce add-to-cart buttons
        $(document).on('click', '.ajax_add_to_cart, .add_to_cart_button', function(e) {
            if (!$(this).hasClass('ajax_add_to_cart') && !$(this).data('product_id')) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            const $btn = $(this);
            const productId = $btn.data('product_id') || $btn.data('product-id');
            const quantity = $btn.data('quantity') || 1;

            if (!productId) return;

            $btn.addClass('loading');
            self.addToCart(productId, quantity, $btn);
        });

        // Single product page form (simple products) - same popup instead of a page reload
        $(document).on('submit', 'form.cart:not(.variations_form):not(.grouped_form)', function(e) {
            const $btn = $(this).find('button[name="add-to-cart"]');
            const productId = parseInt($btn.val(), 10);

            if (!productId) return;

            e.preventDefault();

            if ($btn.hasClass('loading')) return;

            const quantity = parseInt($(this).find('input[name="quantity"]').val(), 10) || 1;

            $btn.addClass('loading');
            self.addToCart(productId, quantity, $btn);
        });

        // Close popup
        $(document).on('click', '.atc-popup__close', function() {
            self.closePopup();
        });

        // Close on overlay click
        $(document).on('click', '.atc-popup-overlay', function(e) {
            if ($(e.target).hasClass('atc-popup-overlay')) {
                self.closePopup();
            }
        });

        // Close on ESC key
        $(document).on('keyup', function(e) {
            if (e.key === 'Escape') {
                self.closePopup();
            }
        });

        // Continue shopping button
        $(document).on('click', '.atc-popup__btn--continue', function(e) {
            e.preventDefault();
            self.closePopup();
        });

        // Add to cart from related products
        $(document).on('click', '.atc-popup__related-add-to-cart', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const $btn = $(this);
            const productId = $btn.data('product-id');

            if (!productId || $btn.hasClass('loading')) return;

            $btn.addClass('loading');
            self.addToCart(productId, 1, $btn);
        });
    },

    addToCart(productId, quantity, $btn) {
        const self = this;

        $.ajax({
            url: settings.ajax_url,
            type: 'POST',
            data: {
                action: 'ajax_add_to_cart_popup',
                product_id: productId,
                quantity: quantity
            },
            success: function(response) {
                $btn.removeClass('loading');

                if (response.success) {
                    self.showPopup(response.data.html);
                    self.updateMiniCartCount(response.data.cart_count, response.data.sliding_cart_html);
                    self.initSlider();
                } else {
                    alert(response.data.message || 'Nie udało się dodać produktu do koszyka.');
                }
            },
            error: function() {
                $btn.removeClass('loading');
                alert('Wystąpił błąd. Spróbuj ponownie.');
            }
        });
    },

    showPopup(html) {
        const $overlay = $('.atc-popup-overlay');
        $overlay.html(html).addClass('active');
        $('body').css('overflow', 'hidden');
    },

    closePopup() {
        const $overlay = $('.atc-popup-overlay');

        if (!$overlay.hasClass('active') || this.closing) {
            return;
        }

        this.closing = true;
        popups.close($overlay[0], $overlay.find('.atc-popup')[0], () => {
            const $slider = $overlay.find('.atc-popup__related-slider');

            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

            $overlay.removeClass('active').empty();
            $('body').css('overflow', '');
            this.closing = false;
        });
    },

    initSlider() {
        const $slider = $('.atc-popup__related-slider');

        if ($slider.length && $slider.children().length > 0) {
            setTimeout(() => {
                $slider.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    prevArrow: $('.atc-popup__related-prev'),
                    nextArrow: $('.atc-popup__related-next'),
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }, 100);
        }
    },

    updateMiniCartCount(count, slidingCartHtml) {
        $('.cart-count, .mini-cart__count, .cart-contents .count').text(count);
        $('.header__link__span').text(count);
        $('.sliding-cart__count').text(count);

        if (typeof wc_cart_fragments_params !== 'undefined') {
            $(document.body).trigger('wc_fragment_refresh');
        }

        // Update sliding cart content directly from the response (no second AJAX needed)
        if (slidingCartHtml) {
            const $parsed = $('<div>').html(slidingCartHtml);
            const $newCart = $parsed.find('.sliding-cart');
            if ($newCart.length) {
                const $existingCart = $('.sliding-cart');
                const $newHeader = $newCart.children('.sliding-cart__header');
                const $newContent = $newCart.children('.sliding-cart__content');
                if ($newHeader.length) $existingCart.children('.sliding-cart__header').replaceWith($newHeader);
                if ($newContent.length) $existingCart.children('.sliding-cart__content').replaceWith($newContent);
            }
        }
    }
};

export default addToCartPopup;
